import { ContractItem, openContract } from '@/ContractConfig';
import { DialogView } from '@hb/coffee';
import { Component, Vue } from 'vue-property-decorator';

const style = require('./index.module.scss') as Dictionary;

@Component({ name: 'LoanContractDialog' })
export default class LoanContractDialog extends Vue {
  private loanItems: ContractItem[] = [];

  private visible = false;

  private orderId = '';

  public show(items: ContractItem[], orderId: string): void {
    this.visible = true;
    this.loanItems = items;
    this.orderId = orderId;
  }

  // 查看合同
  private onCheckLoanContract(index: number): void {
    this.visible = false;
    openContract(this.loanItems[index]);
    this.$ubtPageButtonNew('finance_loan_contract_view', {
      orderId: this.orderId,
      contractName: this.loanItems[index].name,
    });
  }

  private onClose() {
    this.visible = false;
  }

  private render() {
    return (
      <DialogView
        class={style.LoanContract}
        show={ this.visible }
        title="合同列表"
        showConfirmButton={false}
        onCloseIconClick={this.onClose.bind(this)}
      >
        <div class={style.popListItem}>
          {this.loanItems.map((item, index) => (
            <div
              class={style.options}
              onClick={() => this.onCheckLoanContract(index)}
            >
              {item.name}
            </div>
          ))}
        </div>
      </DialogView>
    );
  }
}
